import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=05a75a59&scoped=true&"
import script from "./AddressEdit.vue?vue&type=script&lang=ts&"
export * from "./AddressEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=05a75a59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a75a59",
  null
  
)

export default component.exports